import type { TableColumn } from "../../../../../../components/table";

export const tableColumns: TableColumn<any>[] = [
  {
    title: "STT",
    size: "medium",
    renderCell: (row, index) => index,
  },
  {
    title: "Người sử dụng",
    renderCell: (row) => row.Users,
  },
  {
    title: "Mã nhân viên",
    renderCell: (row) => row.NameSupplies,
  },
  {
    title: "Bộ phận công tác",
    renderCell: (row) => row.WorkingDepartment,
  },
  {
    title: "Chi tiết đề nghị",
    renderCell: (row) => row.SuggestionDetails,
  },
  {
    title: "Lý do",
    renderCell: (row) => row.DegreeTraining,
  },
];
